if (!customElements.get('christmas-card')) {
  customElements.define(
    'christmas-card',
    class ChristmasCard extends HTMLElement {
      constructor() {
        super();

        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.fields = this.querySelector('.christmas-card__fields');
        this.textInputs = this.fields.querySelectorAll('input, textarea');
        this.message = this.querySelector('textarea');
        this.counter = this.querySelector('[data-count]');
        this.maxChars = parseInt(this.getAttribute('data-max-chars'));
        this.save = theme.utils.debounce(this.save.bind(this), 400);
      }

      connectedCallback() {
        this.checkbox.addEventListener('change', this.onToggle.bind(this));
        this.fields.addEventListener('input', this.onInput.bind(this));
      }

      onToggle() {
        const checked = this.checkbox.checked;
        this.fields.hidden = !checked;
        this.textInputs.forEach((input) => (input.disabled = !checked));
        this.save();
      }

      onInput(event) {
        if (event.target === this.message) {
          this.counter.textContent = `${this.message.value.length}/${this.maxChars}`;
        }
        this.save();
      }

      // Unticking clears every card attribute so nothing stale reaches the order.
      save() {
        const checked = this.checkbox.checked;
        const attributes = { [this.attributeName(this.checkbox)]: checked ? 'Yes' : '' };
        this.textInputs.forEach((input) => {
          attributes[this.attributeName(input)] = checked ? input.value.trim() : '';
        });

        const body = JSON.stringify({ attributes });
        fetch(theme.routes.cart_update_url, { ...theme.utils.fetchConfig(), ...{ body } }).catch((error) => {
          console.log(error);
        });
      }

      attributeName(input) {
        return input.name.replace(/^attributes\[(.*)\]$/, '$1');
      }
    }
  );
}
